import React, { useState } from 'react';
import { ShieldIcon } from '../../../icons/ShieldIcon';
import { KeyIcon } from '../../../icons/KeyIcon';
import {
  DashboardApplicationGroup,
  DashboardColumnKind,
  DashboardRole,
} from './types';
import { DashboardApplicationGroupView } from './DashboardApplicationGroup';
import {
  ColumnCard,
  ColumnHeader,
  ColumnIconWrap,
  ColumnSubtitle,
  ColumnTitle,
  EmptyColumnMessage,
} from './styles';

interface AccessDashboardColumnProps {
  kind: DashboardColumnKind;
  title: string;
  subtitle: string;
  groups: DashboardApplicationGroup[];
  initialExpandedRoleId?: string;
  pendingRequestRoleIds?: ReadonlySet<string>;
  onRequestAccess?: (role: DashboardRole) => void;
}

export function AccessDashboardColumn({
  kind,
  title,
  subtitle,
  groups,
  initialExpandedRoleId,
  pendingRequestRoleIds,
  onRequestAccess,
}: AccessDashboardColumnProps) {
  const Icon = kind === 'granted' ? ShieldIcon : KeyIcon;
  const [expandedRoleId, setExpandedRoleId] = useState<string | null>(
    initialExpandedRoleId ?? null,
  );

  const handleToggleRole = (roleId: string) => {
    setExpandedRoleId(current => (current === roleId ? null : roleId));
  };

  return (
    <ColumnCard>
      <ColumnHeader>
        <ColumnIconWrap>
          <Icon />
        </ColumnIconWrap>
        <div>
          <ColumnTitle>{title}</ColumnTitle>
          <ColumnSubtitle>{subtitle}</ColumnSubtitle>
        </div>
      </ColumnHeader>
      {groups.length === 0 ? (
        <EmptyColumnMessage>
          {kind === 'granted'
            ? 'No roles granted in this team.'
            : 'No roles available to request in this team.'}
        </EmptyColumnMessage>
      ) : (
        groups.map(group => (
          <DashboardApplicationGroupView
            key={group.application.id}
            group={group}
            kind={kind}
            expandedRoleId={expandedRoleId}
            onToggleRole={handleToggleRole}
            pendingRequestRoleIds={pendingRequestRoleIds}
            onRequestAccess={onRequestAccess}
          />
        ))
      )}
    </ColumnCard>
  );
}
